import React, { useState, useEffect, useRef } from "react";
import { Form, Modal } from "react-bootstrap";

function LoginModal({ showThis, getPass }) {
  const [show, setShow] = useState(showThis);
  const inputRef = useRef(null); // Create a ref for the input

  useEffect(() => {
    setShow(showThis);
    if (showThis) {
      setTimeout(() => {
        inputRef.current?.focus(); // Focus the input when the modal is displayed
      }, 100); // Slight delay to ensure the modal is fully mounted
    }
  }, [showThis]);

  return (
    <>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Sign-In</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Enter pass:</Form.Label>
              <Form.Control
                ref={inputRef} // Attach the ref to the Form.Control
                onChange={(v) => getPass(v.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default LoginModal;
